import { useEffect, useState } from "react";

const Loader = ({
    active = true,
    delay = 250,
    fullScreen = false,
    inline = false,
    label = "Loading...",
}) => {
    const [visible, setVisible] = useState(delay === 0 && active);

    useEffect(() => {
        if (!active) {
            setVisible(false);
            return;
        }

        if (delay === 0) {
            setVisible(true);
            return;
        }

        const timer = setTimeout(() => setVisible(true), delay);
        return () => clearTimeout(timer);
    }, [active, delay]);

    if (!active || !visible) return null;

    const content = (
        <div className={`app-loader ${inline ? "app-loader--inline" : ""}`}>
            <div className="app-loader__ring" />
            <p className="app-loader__label">{label}</p>
        </div>
    );

    if (fullScreen) {
        return <div className="app-loader-backdrop">{content}</div>;
    }

    return content;
};

export default Loader;
